import Route from '@ember/routing/route';
import { inject as iService } from '@ember/service';
import { set } from '@ember/object';

export default class ConfirmRoute extends Route {
  @iService session;
  @iService intl;

  model() {}

  async beforeModel(transition) {
    await super.beforeModel(transition);
    this.intl.setLocale(['en-US', 'en-GB', 'it-IT', 'fr-FR', 'de-DE']);

    const controller = this.controllerFor('application');
    this.session.setAnonymous(true);
    await this.session.bootstrapSession(transition, controller);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    const application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }
}
